import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'leadingZero',
    standalone: false
})
export class LeadingZeroPipe implements PipeTransform {

  transform(value: number | string | null): string {
    
    if (!value) {
      return '00';
    }

    if (
      (typeof(value) === 'string' && value.length < 2) ||
      (typeof(value) === 'number' && value <= 9)
      ) {
      return `0${value}`;
    }

    return value.toString();
  }

}
